import { z } from 'zod'

export const unitSchema = z.object({
  unit_number: z.string().min(1, 'Unit number is required').max(50),
  unit_type: z.enum(['RESIDENTIAL', 'PARKING', 'CELLAR', 'COMMERCIAL'], {
    errorMap: () => ({ message: 'Please select a valid unit type' }),
  }),
  floor: z.number().int().nullable().optional(),
  stairwell: z.string().max(50).nullable().optional(),
  area_sqm: z.number().positive('Area must be positive').nullable().optional(),
  general_shares: z.number().int('Must be a whole number').min(0, 'Cannot be negative'),
  work_fund_share: z.number().int('Must be a whole number').min(0, 'Cannot be negative').nullable().optional(),
  notes: z.string().nullable().optional(),
  residence_id: z.string().uuid('Invalid residence ID'),
})

export type UnitFormData = z.infer<typeof unitSchema>
